/** Moving your own benched Pokémon and hand cards around, at any time: a tidy-up, not a move of the game. */
export const ARRANGE_BENCH = 'ARRANGE/ARRANGE_BENCH';
export const ARRANGE_HAND = 'ARRANGE/ARRANGE_HAND';
